var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77366 0.666748H20.2137C24.747 0.666748 27.3337 3.22675 27.3337 7.77341V20.2267C27.3337 24.7467 24.7603 27.3334 20.227 27.3334H7.77366C3.22699 27.3334 0.666992 24.7467 0.666992 20.2267V7.77341C0.666992 3.22675 3.22699 0.666748 7.77366 0.666748ZM15.0937 15.1067H18.8803C19.4937 15.0934 19.987 14.6001 19.987 13.9867C19.987 13.3734 19.4937 12.8801 18.8803 12.8801H15.0937V9.12008C15.0937 8.50675 14.6003 8.01342 13.987 8.01342C13.3737 8.01342 12.8803 8.50675 12.8803 9.12008V12.8801H9.10699C8.81366 12.8801 8.53366 13.0001 8.32033 13.2001C8.12033 13.4134 8.00033 13.6921 8.00033 13.9867C8.00033 14.6001 8.49366 15.0934 9.10699 15.1067H12.8803V18.8801C12.8803 19.4934 13.3737 19.9867 13.987 19.9867C14.6003 19.9867 15.0937 19.4934 15.0937 18.8801V15.1067Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/add-square.3c4221d7.svg";
export { ForwardRef as ReactComponent };